export default "__VITE_PUBLIC_ASSET__74ca7e0e__"